// Linkout waterfall logics whose winner is picked from the entries' pre-ping responses before the
// offer renders. PRE_PING_BASED_CTR is the same, with each ad's bid weighted by its carrier's CTR.
export const PRE_PING_BASED_LOGICS = ['PRE_PING_BASED', 'PRE_PING_BASED_CTR'];

export const isPrePingBasedLogic = (waterfallLogic) => PRE_PING_BASED_LOGICS.includes(waterfallLogic);

export const handleOfferActionSubtypeInit = (offerAction) => {
  let initData = { title: offerAction.title, offerActionType: offerAction.offerActionType, offerAction };
  if (offerAction.offerActionType?.includes('WATERFALL')) {
    const offerActionTypeName =
      offerAction.offerActionType === 'POST_WATERFALL' ? 'offerActionPostWaterfall' : 'offerActionLinkoutWaterfall';
    initData = { ...initData, ...handleWaterfallInit(offerAction[offerActionTypeName]) };
  }

  return initData;
};

export const handleWaterfallInit = (actionWaterfall) => {
  const waterfall = {
    id: actionWaterfall.id,
    waterfallLogic: actionWaterfall.waterfallLogic ?? 'FLEX',
    maxNumSuccesses: actionWaterfall.maxNumSuccesses ?? 1,
  };
  console.log(actionWaterfall);
  if (actionWaterfall.offerActionPostWaterfallEntries) {
    waterfall.offerActionPostWaterfallEntries = mapWaterfallEntries(actionWaterfall.offerActionPostWaterfallEntries);
  } else if (actionWaterfall.offerActionLinkoutWaterfallEntries) {
    waterfall.offerActionLinkoutWaterfallEntries = mapWaterfallEntries(
      actionWaterfall.offerActionLinkoutWaterfallEntries
    );
  }
  console.log(waterfall);
  return waterfall;
};

const mapWaterfallEntries = (waterfallEntries) => {
  return waterfallEntries
    .map((entry) => {
      // Entry points to a nested waterfall
      if (entry.nestedOfferActionLinkoutWaterfall) {
        const nlw = entry.nestedOfferActionLinkoutWaterfall;
        return {
          id: entry.id,
          flex: parseInt(entry.flex),
          entryType: 'waterfall',
          nestedOfferActionLinkoutWaterfall: {
            id: nlw.id,
            offerActionId: nlw.offerAction ? nlw.offerAction.id : null,
            name: nlw.offerAction ? nlw.offerAction.title : null,
            title: nlw.offerAction ? nlw.offerAction.title : null,
          },
          advertiser: null,
          orderBy: entry.orderBy,
        };
      }
      // Entry points to a regular linkout or post
      const actionSubtype = entry.offerActionPost ? 'offerActionPost' : 'offerActionLinkout';
      return {
        id: entry.id,
        flex: parseInt(entry.flex),
        entryType: 'linkout',
        [actionSubtype]: entry[actionSubtype],
        advertiser: entry[actionSubtype]
          ? entry[actionSubtype].advertiser && entry[actionSubtype].advertiser?.name
          : null,
        orderBy: entry.orderBy,
      };
    })
    .sort((a, b) => a.orderBy - b.orderBy);
};

export const parseOfferActionSubtype = (offerAction) => {
  switch (offerAction.offerActionType) {
    case 'POST_WATERFALL':
    case 'LINKOUT_WATERFALL':
      return handleWaterfallSubmit(offerAction);
    default:
      return undefined;
  }
};

const handleWaterfallSubmit = (values) => {
  const actionSubtypeEntries =
    values.offerActionType === 'POST_WATERFALL'
      ? 'offerActionPostWaterfallEntries'
      : 'offerActionLinkoutWaterfallEntries';
  const actionSubtype = values.offerActionType === 'POST_WATERFALL' ? 'offerActionPost' : 'offerActionLinkout';

  const waterfall = {
    [actionSubtypeEntries]: values[actionSubtypeEntries].map((entry, i) => {
      // Nested waterfall entry
      if (entry.entryType === 'waterfall' && entry.nestedOfferActionLinkoutWaterfall) {
        return {
          flex: parseInt(entry.flex),
          id: entry.id,
          offerActionLinkout: null,
          nestedOfferActionLinkoutWaterfall: { id: entry.nestedOfferActionLinkoutWaterfall.id },
          orderBy: i,
        };
      }
      // Regular linkout entry
      return {
        flex: parseInt(entry.flex),
        id: entry.id,
        [actionSubtype]: entry[actionSubtype],
        nestedOfferActionLinkoutWaterfall: null,
        orderBy: i,
      };
    }),
    waterfallLogic: values.waterfallLogic || 'FLEX',
  };

  if (actionSubtype === 'offerActionPost') {
    waterfall.maxNumSuccesses = parseInt(values.maxNumSuccesses) || 1;
  }

  if (values.id) {
    waterfall.id = values.id;
  }
  return waterfall;
};

export const calculatePercentages = (weights) => {
  const percentages = {};
  let totalWeights = weights.reduce((acc, weight) => acc + weight, 0);

  weights.forEach((weight, index) => {
    const weightedFlex = parseFloat((weight / totalWeights) * 100).toFixed(2);
    percentages[`percent-${index}`] = weightedFlex;
  });

  return percentages;
};
